import React from 'react'

const Container = ({ children }) => {
    return (
        <div
            className='bg-white p-3 relative w-full rounded-[3px] shadow-3 mt-3 mb-5'
            style={{
                borderTop: '3px solid #d2d6de'
            }}
        >
            {children}
        </div>
    )
}

export default Container
